export default "__VITE_ASSET__D4grl2lc__"